<div class="flex justify-center">
  <div class="max-w-[1400px] w-full">
    <zaeper-page-layout [pageLayout]="ePageLayout.PLAIN">
      <div class="flex flex-col gap-6 items-center w-full">
        <div class="w-fit">
          <zaeper-toggle-button [buttons]="toggleButtons" (onChange)="switchView($event)"/>
        </div>
        @if (activeIndex() === 0) {
          <app-apps-overview-tab-component class="w-full"/>
        }
        @if (activeIndex() === 1) {
          <app-launchers-overview-tab-component class="w-full"/>
        }
        @if (activeIndex() === 2) {
          <app-widgets-overview-tab-component class="w-full"/>
        }
      </div>
    </zaeper-page-layout>
  </div>
</div>
